import { ProductId } from 'src/replicant/iap';
import { ShoppingCart } from './Icons';
import { getProductDataById } from 'src/lib/iap/iap.util';
import { getProductName } from './Config';

export function PaymentDetails({ productId }: { productId: ProductId }) {
  const product = getProductDataById(productId);
  // Extract currency symbol from the price. $0.99 -> $ and 0.99
  // $0,99 -> $ and 0,99
  const regex = /[^0-9.,]/g;
  const currencySymbol = product.price.match(regex);
  const price = product.price.replace(regex, '');
  const title = getProductName(productId);

  return (
    <div class="details">
      <div class="price">
        <div class="currencySymbol" id="paymentCurrencySymbol">
          {currencySymbol}
        </div>
        <div class="amount" id="paymentCurrencyAmount">
          {price}
        </div>
        <div class="currency" id="paymentCurrency">
          ({product.currencyCode})
        </div>
      </div>
      <div class="description">
        <ShoppingCart />
        <div id="paymentItem">{title}</div>
      </div>

      <div class="divider"></div>
    </div>
  );
}
